module.exports = __webpack_public_path__ + "img/more-activity-card1.4b979fe8.png";